'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$17() {
  this.bfe = null;
  this.bfc = null;
  this.bfd = false;
  this.bfa = null;
  this.bfb = false;
  this.bff = false;
  this.bfg = false;
  this.bfe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$17 as $c_Lpresto_PrestoRouter$$anon$17 };
$p = $c_Lpresto_PrestoRouter$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$17;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$17() {
}
export { $h_Lpresto_PrestoRouter$$anon$17 as $h_Lpresto_PrestoRouter$$anon$17 };
$h_Lpresto_PrestoRouter$$anon$17.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bfe;
});
$p.t = (function() {
  if ((!this.bfd)) {
    this.bfc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfd = true;
  }
  return this.bfc;
});
$p.ae = (function() {
  if ((!this.bfb)) {
    this.bfa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfb = true;
  }
  return this.bfa;
});
$p.w = (function() {
  if ((!this.bfg)) {
    this.bff = false;
    this.bfg = true;
  }
  return this.bff;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$17, "presto.PrestoRouter$$anon$17", ({
  NH: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$17 as $d_Lpresto_PrestoRouter$$anon$17 };
//# sourceMappingURL=presto.-Presto-Router$$anon$17.js.map
